import { __rest, __assign } from 'tslib';
import React from 'react';
import { useIntl } from 'react-intl';
import { CloseIcon } from '@panwds/icons';
import { Button } from '../Button/Button.esm.js';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/FaIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { CardHeader } from '../Card/CardHeader.esm.js';
import { useModalContext } from './Modal.esm.js';

function CloseButton(props) {
    var intl = useIntl();
    return (React.createElement(Button, __assign({ appearance: "tertiary-clear", "aria-label": intl.formatMessage({ id: "4VwnfS", defaultMessage: [{ type: 0, value: "Close modal" }] }), icon: React.createElement(CloseIcon, { size: "xs" }), size: "sm" }, props)));
}
/**
 * A styled container to be used within a Modal.
 */
function ModalHeader(_a) {
    var actions = _a.actions, _b = _a.appearance, appearance = _b === void 0 ? "primary" : _b, _c = _a.enableClose, enableClose = _c === void 0 ? true : _c, passThrough = __rest(_a, ["actions", "appearance", "enableClose"]);
    var closeModalWithConfirm = useModalContext().closeModalWithConfirm;
    return (React.createElement(CardHeader, __assign({}, passThrough, { appearance: appearance, actions: React.createElement(React.Fragment, null,
            actions,
            enableClose && React.createElement(CloseButton, { onClick: closeModalWithConfirm })) })));
}

export { ModalHeader };
//# sourceMappingURL=ModalHeader.esm.js.map
